export default __webpack_public_path__ + "static/russian-6-c6520c23be2b435453bd6db124ae0625.jpg";